<n-slide-window [(visible)]="show"
    id="exportSimpleSlideWindow"
    width="4.16rem"
    [loading]="loading"
    (onHide)="onHide()"
    *ngIf="isSimpleSettingsEntrance">
    <n-header class="flex-wrapper">
        <h1 [innerHTML]="i18n.title"></h1>
        <n-help-link key="simplifyInfo"></n-help-link>
    </n-header>

    <ng-container [ngTemplateOutlet]="simpleLogBody"></ng-container>

    <n-footer>
        <button nButton
            type="button"
            (click)="onClose()"
            [label]="i18n.closeBtn">
        </button>
    </n-footer>
</n-slide-window>

<ng-container [ngTemplateOutlet]="simpleLogBody" *ngIf="!isSimpleSettingsEntrance"></ng-container>

<ng-template #simpleLogBody>
    <!-- 极简模式下的“日志导出” -->
    <div class="simple-log-container">
        <div class="simple-log-body">
            <!-- 建议处理方式 -->
            <div>
                <h2 class="section-title">{{str.i18nLabel.recommendedMethod}}</h2>
                <span class="sub">{{str.i18nLabel.recommendedDes}}</span>
            </div>

            <!-- 日志类型（用slice将数组隔开，区分系统信息和诊断信息） -->
            <div class="simple-log-type-box">
                <n-radio-group [ngModel]="selectedType" (onChange)="onClickItem($event)">
                    <n-radio [id]="'simple-log-item-' + item.type"
                        *ngFor="let item of exportItems"
                        [value]="item.type" class="box-item">
                        {{item.label}}
                    </n-radio>
                </n-radio-group>
            </div>

            <!-- 数据加密 -->
            <form [formGroup]="formGroup"
                autocomplete="off"
                [errorMessage]="errorMessage"
                [simpleMode]="true"
                *ngIf="selectedType !== logType.performanceFile && selectedType !== logType.DISK_RUNING_STATUS_DATA">
                <n-form-item [label]="i18n.encryptLab" id="simple-log-encrypt">
                    <n-switch id="simple-log-encrypt-switch"
                        formControlName="encryption"
                        (onChange)="restInput()">
                    </n-switch>
                    <n-tip *ngIf="formGroup.value.encryption"
                        [type]="'info'"
                        [content]="i18n.useEncryptTip">
                    </n-tip>
                </n-form-item>
                <ng-container *ngIf="formGroup && formGroup.value.encryption">
                    <!-- 加密口令 -->
                    <n-form-item [label]="i18n.encryptPasswordLab"
                        [required]="true">
                        <!-- 添加一个隐藏的输入框来欺骗firefox等浏览器的自动填充 -->
                        <input type="password" class="hidden">
                        <input nInput
                            id="simple-log-encrypt-password-input"
                            type="password"
                            autocomplete="off"
                            autofocus
                            formControlName="key"
                            [placeholder]="errorMessage.key.rangeByteLength"
                            [nTooltip]="keyTip"
                            nTooltipTrigger="focus"
                            [nTooltipPlacement]="'top'" />
                        <ng-template #keyTip>
                            <ul class="input-tip">
                                <li *ngFor="let item of keyTips"
                                    [innerHTML]="item">
                                </li>
                            </ul>
                        </ng-template>
                    </n-form-item>
                    <!-- 确认口令 -->
                    <n-form-item [label]="i18n.encryptConfirmPasswordLab"
                        [required]="true">
                        <input nInput
                            id="simple-log-encrypt-confirmPassword-input"
                            type="password"
                            autocomplete="off"
                            [placeholder]="errorMessage.key.rangeByteLength"
                            formControlName="confirmKey"
                            onpaste="return false;" />
                    </n-form-item>
                </ng-container>
            </form>

            <!-- 日志导出选项 -->
            <n-block class="export-btn-area" [title]="i18n.downloadLogLabel">
                <!-- 系统日志 -->
                <ng-container *ngIf="selectedType === logType.system">
                    <!-- 近期日志 -->
                    <div *ngIf="btnMap[logType.system].visible" class="mr30 log-item">
                        <app-log-label-and-btn [logLabel]="btnMap[logType.system].label"
                            [helpContent]="i18n.exportRecentLogTip"
                            [helpIconHidden]="recentBtnDisable || FeatureConfig.IsHideCabinetAndExpansion"
                            btnId="simple-log-recent-btn"
                            [btnLabel]="i18n.downloadBtn"
                            [btnDisabled]="recentBtnDisable"
                            [btnDisabledTip]="recentBtnDisableTip"
                            [btnLoading]="btnMap[logType.system].loading"
                            (clickBtn)="onDownload(logType.system)">
                        </app-log-label-and-btn>

                        <app-simple-time-and-size tipId="simple-log-system-log-tip"
                            [hidden]="recentBtnDisable" [exportLog]="btnMap[logType.system]">
                        </app-simple-time-and-size>
                    </div>
                    <!-- 全部日志 -->
                    <div *ngIf="btnMap[logType.system+'all'].visible" class="mr30 log-item">
                        <app-log-label-and-btn [logLabel]="btnMap[logType.system+'all'].label"
                            btnId="simple-log-all-log-btn"
                            [btnLabel]="i18n.downloadBtn"
                            [btnDisabled]="suportNodeExportBtnDisable"
                            [btnDisabledTip]="numUpLimitTip"
                            [btnLoading]="btnMap[logType.system+'all'].loading"
                            (clickBtn)="onDownload(logType.system, true)">
                        </app-log-label-and-btn>

                        <app-simple-time-and-size tipId="simple-log-system-all-log-tip"
                            [hidden]="suportNodeExportBtnDisable" [exportLog]="btnMap[logType.system+'all']">
                        </app-simple-time-and-size>
                    </div>
                    <!-- 关键日志 -->
                    <div *ngIf="btnMap[logType.system+'private'].visible" class="log-item">
                        <app-log-label-and-btn [logLabel]="btnMap[logType.system+'private'].label"
                            btnId="simple-log-private-btn"
                            [btnLabel]="i18n.downloadBtn"
                            [btnDisabled]="suportNodeExportBtnDisable"
                            [btnDisabledTip]="numUpLimitTip"
                            [btnLoading]="btnMap[logType.system+'private'].loading"
                            (clickBtn)="onDownload(logType.system, null, true)">
                        </app-log-label-and-btn>

                        <app-simple-time-and-size tipId="simple-log-system-private-log-tip"
                            [hidden]="suportNodeExportBtnDisable" [exportLog]="btnMap[logType.system+'private']">
                        </app-simple-time-and-size>
                    </div>
                </ng-container>
                <!-- 硬盘日志 -->
                <ng-container *ngIf="selectedType === logType.disk">
                    <!-- DHA运行日志 -->
                    <div *ngIf="btnMap[logType.dha].visible" class="mr30 log-item">
                        <app-log-label-and-btn [logLabel]="btnMap[logType.dha].label"
                            btnId="simple-log-dha-log-btn"
                            [btnLabel]="i18n.downloadBtn"
                            [btnDisabled]="suportNodeExportBtnDisable"
                            [btnDisabledTip]="numUpLimitTip"
                            [btnLoading]="btnMap[logType.dha].loading"
                            (clickBtn)="onDownload(logType.dha)">
                        </app-log-label-and-btn>

                        <app-simple-time-and-size tipId="simple-log-dha-log-tip"
                            [hidden]="suportNodeExportBtnDisable" [exportLog]="btnMap[logType.dha]">
                        </app-simple-time-and-size>
                    </div>
                    <!-- HSSD日志 -->
                    <div *ngIf="btnMap[logType.hssd].visible" class="mr30 log-item">
                        <app-log-label-and-btn [logLabel]="btnMap[logType.hssd].label"
                            btnId="simple-log-hssd-log-btn"
                            [btnLabel]="i18n.downloadBtn"
                            [btnDisabled]="suportNodeExportBtnDisable"
                            [btnDisabledTip]="numUpLimitTip"
                            [btnLoading]="btnMap[logType.hssd].loading"
                            (clickBtn)="onDownload(logType.hssd)">
                        </app-log-label-and-btn>

                        <app-simple-time-and-size tipId="simple-log-hssd-log-tip"
                            [hidden]="suportNodeExportBtnDisable" [exportLog]="btnMap[logType.hssd]">
                        </app-simple-time-and-size>
                    </div>
                    <!-- 硬盘数据擦除报告 -->
                    <div *ngIf="btnMap[logType.erase].visible" class="log-item">
                        <app-log-label-and-btn [logLabel]="btnMap[logType.erase].label"
                            btnId="simple-log-erase-log-btn"
                            [btnLabel]="i18n.downloadBtn"
                            [btnDisabled]="isExportByNode"
                            [btnDisabledTip]="eraseBtnDisableTip"
                            [btnLoading]="btnMap[logType.erase].loading"
                            (clickBtn)="onDownload(logType.erase)">
                        </app-log-label-and-btn>

                        <app-simple-time-and-size tipId="simple-log-erase-log-tip"
                            [hidden]="isExportByNode" [exportLog]="btnMap[logType.erase]">
                        </app-simple-time-and-size>
                    </div>
                </ng-container>
                <!-- 硬盘数据 -->
                <ng-container *ngIf="selectedType === logType.DISK_RUNING_STATUS_DATA">
                    <div class="log-item">
                        <app-log-label-and-btn [logLabel]="i18n.diskRunningStatusLable"
                            btnId="simple-log-disk-running-status-data-log-btn"
                            [btnLabel]="i18n.downloadBtn"
                            [btnLoading]="btnMap[logType.DISK_RUNING_STATUS_DATA].loading"
                            (clickBtn)="onDownload(logType.DISK_RUNING_STATUS_DATA)">
                        </app-log-label-and-btn>
                        <app-simple-time-and-size tipId="simple-log-disk-running-status-data-log-tip"
                            [hidden]="false" [exportLog]="btnMap[logType.DISK_RUNING_STATUS_DATA]">
                        </app-simple-time-and-size>
                    </div>
                </ng-container>
                <!-- cloudBackup -->
                <ng-container *ngIf="selectedType === logType.cloudBackup">
                    <div *ngIf="btnMap[logType.cloudBackup].visible" class="log-item">
                        <app-log-label-and-btn [logLabel]="btnMap[logType.cloudBackup].label"
                            btnId="simple-log-cloudBackup-log-btn"
                            [btnLabel]="i18n.downloadBtn"
                            [btnLoading]="btnMap[logType.cloudBackup].loading"
                            (clickBtn)="onDownload(logType.cloudBackup)">
                        </app-log-label-and-btn>
                    </div>
                    <!-- 全部日志 -->
                    <div *ngIf="btnMap[logType.cloudBackup+'all'].visible" class="log-item">
                        <app-log-label-and-btn [logLabel]="btnMap[logType.cloudBackup+'all'].label"
                            btnId="simple-log-cloudBackup-all-log-btn"
                            [btnLabel]="i18n.downloadBtn"
                            [btnLoading]="btnMap[logType.cloudBackup+'all'].loading"
                            (clickBtn)="onDownload(logType.cloudBackup, true)">
                        </app-log-label-and-btn>
                    </div>
                </ng-container>
                <!-- 配置信息 -->
                <ng-container *ngIf="selectedType === logType.runningData">
                    <div class="log-item">
                        <app-log-label-and-btn [logLabel]="i18n.runningDataLabel"
                            btnId="simple-log-runningData-log-btn"
                            [btnLabel]="i18n.downloadBtn"
                            [btnLoading]="btnMap[logType.runningData].loading"
                            (clickBtn)="onDownload(logType.runningData)">
                        </app-log-label-and-btn>

                        <app-simple-time-and-size tipId="simple-log-runningData-log-tip"
                            [hidden]="false" [exportLog]="btnMap[logType.runningData]">
                        </app-simple-time-and-size>
                    </div>
                </ng-container>
                <!-- 全量故障诊断信息 -->
                <ng-container *ngIf="selectedType === logType.diagnostic">
                    <div class="log-item">
                        <app-log-label-and-btn [logLabel]="i18n.diagnosticLabel"
                            btnId="simple-log-diagnostic-log-btn"
                            [btnLabel]="i18n.downloadBtn"
                            [btnLoading]="btnMap[logType.diagnostic].loading"
                            (clickBtn)="onDownload(logType.diagnostic)">
                        </app-log-label-and-btn>

                        <app-simple-time-and-size tipId="simple-log-diagnostic-log-tip"
                            [hidden]="false" [exportLog]="btnMap[logType.diagnostic]">
                        </app-simple-time-and-size>
                    </div>
                </ng-container>
                <!-- 防病毒日志 -->
                <ng-container *ngIf="selectedType === logType.antivirus">
                    <div *ngIf="btnMap[logType.antivirus].visible" class="log-item">
                        <app-log-label-and-btn [logLabel]="i18n.antivirusLabel"
                            btnId="simple-log-antivirus-log-btn"
                            [btnLabel]="i18n.downloadBtn"
                            [btnLoading]="btnMap[logType.antivirus].loading"
                            (clickBtn)="onDownload(logType.antivirus)">
                        </app-log-label-and-btn>
                    </div>
                </ng-container>
                <!-- FTDS日志 -->
                <ng-container *ngIf="selectedType === logType.ftds">
                    <div *ngIf="btnMap[logType.ftds].visible" class="log-item">
                        <app-log-label-and-btn [logLabel]="i18n.ftdsLabel"
                            btnId="simple-log-ftds-log-btn"
                            [btnLabel]="i18n.downloadBtn"
                            [btnLoading]="btnMap[logType.ftds].loading"
                            (clickBtn)="onDownload(logType.ftds)">
                        </app-log-label-and-btn>

                        <app-simple-time-and-size tipId="simple-log-ftds-log-tip"
                            [hidden]="false" [exportLog]="btnMap[logType.ftds]">
                        </app-simple-time-and-size>
                    </div>
                </ng-container>
                <!-- 性能文件 -->
                <ng-container *ngIf="selectedType === logType.performanceFile">
                    <ng-container *ngIf="hasConfigPMS; else PMSTip">
                        <div>
                            <!-- 文件日期区间 -->
                            <p>{{i18n.exportDataTimeLabel}}</p>
                            <n-calendar-section
                                [disabled]="btnMap[logType.performanceFile].loading"
                                class="mt10"
                                format="YYYY-MM-DD"
                                showDstWithoutTimePicker="true"
                                [(ngModel)]="dateRange"
                                (onFocus)="hideResult([logType.performanceFile])"
                                (onChange)="ondateRangeChange()">
                            </n-calendar-section>
                            <!-- 取消导出的tip -->
                            <n-help-icon class="title-tip" [content]="i18n.cancelExportPerfTip"></n-help-icon>
                            <!-- 超出可选日期的tip -->
                            <p class="mt10" *ngIf="!isTimeRangeValid">
                                <svg class="icon operation">
                                    <use xlink:href="#app-icon-alarms-minor-new"></use>
                                </svg>
                                {{str.exportDataTimeLimitTip(30)}}
                            </p>
                        </div>
                        <div class="log-item mt10">
                            <div class="flex-style">
                                <app-log-label-and-btn [logLabel]="i18n.performanceFileLabel"
                                    btnId="simple-log-performanceFile-log-btn"
                                    class="inline-block"
                                    [btnLabel]="i18n.downloadBtn"
                                    [btnLoading]="btnMap[logType.performanceFile].loading"
                                    [btnDisabled]="!isTimeRangeValid"
                                    (clickBtn)="onDownload(logType.performanceFile)">
                                </app-log-label-and-btn>
                                <!-- 取消导出 -->
                                <app-log-label-and-btn btnId="simple-cancel-performanceFile-log-btn"
                                    class="inline-block"
                                    [btnLabel]="i18n.cancelBtn"
                                    [btnLoading]="isCancelExportPerf"
                                    (clickBtn)="cancelExportPerfLog()">
                                </app-log-label-and-btn>
                            </div>

                            <app-simple-time-and-size tipId="simple-log-performanceFile-log-tip"
                                [hidden]="false" [exportLog]="btnMap[logType.performanceFile]">
                            </app-simple-time-and-size>
                        </div>
                    </ng-container>
                    <!-- 不支持导出性能文件 -->
                    <ng-template #PMSTip>
                        <p>
                            {{i18n.noPmsLunNoDataTip}}
                            <a (click)="jumpToConfigPmsLun()">{{i18n.noPmsLunHistoricalDataTip}}</a>{{i18n.preiodLab}}
                        </p>
                    </ng-template>
                </ng-container>

                <!-- 精简故障诊断信息 -->
                <ng-container *ngIf="selectedType === logType.streamlineDiagnostic">
                    <app-streamline-dianostic [encryptionVm]="formGroup">
                    </app-streamline-dianostic>
                </ng-container>

                <n-tip *ngIf="resultMap[selectedType]?.show"
                    [type]="resultMap[selectedType]?.isOk ? 'succeed' : 'error'">
                    {{resultMap[selectedType].result}}
                </n-tip>
            </n-block>

            <!-- 系统日志-导出进度 -->
            <div *ngIf="selectedType === logType.system" class="percent-bar-box">
                <n-percent-bar *ngIf="(btnMap[logType.system].loading) || (btnMap[logType.system + 'all'].loading)"
                    style="flex: 1;" defaultColor="#2673E5"
                    [toFixed]="0"
                    [value]="downloadProcess">
                </n-percent-bar>
            </div>

            <!-- 防病毒日志-导出进度 -->
            <div *ngIf="selectedType === logType.antivirus " class="percent-bar-box">
                <n-percent-bar *ngIf="btnMap[logType.antivirus].loading"
                    style="flex: 1;" defaultColor="#2673E5"
                    [toFixed]="0"
                    [value]="downloadProcess">
                </n-percent-bar>
            </div>

            <!-- FTDS日志-导出进度 -->
            <div *ngIf="selectedType === logType.ftds" class="percent-bar-box">
                <n-percent-bar *ngIf="btnMap[logType.ftds].loading"
                    style="flex: 1;" defaultColor="#2673E5"
                    [toFixed]="0"
                    [value]="downloadProcess">
                </n-percent-bar>
            </div>

            <!-- 导出结果表格 -->
            <div class="log-list mt10"
                [class.show]="showTable">
                <n-data-table #dt
                    [style.height]="showTable ? '300px' : '1px'"
                    id="simple-log-exportlog-list"
                    [loading]="tableLoading"
                    [config]="tableConfig"
                    [columnDefs]="tableColumnDefs">
                    <ng-template nTemplate
                        [meta]="{field: 'status'}"
                        let-data="rowData">
                        <svg class="icon">
                            <use [attr.xlink:href]="icon[data.status]"></use>
                        </svg>
                        <span [class.red]="data.status === downloadStatus.failed">
                            {{statusMap[data.status]}}
                        </span>
                    </ng-template>
                </n-data-table>
            </div>
        </div>

        <n-footer *ngIf="!isSimpleSettingsEntrance">
            <!-- 取消 -->
            <button nButton [label]="i18n.cancelBtn"
                id="simple-log-cancel-btn"
                (click)="onClose()">
            </button>
        </n-footer>
    </div>
</ng-template>
